<img src="./assets/nolia/logo/isotipo.png" alt="Nolia" width="64" height="74" />
<div class="app-init-loader__spinner"></div>
